import { Component, Input, OnInit } from '@angular/core';
import { PHPermissions } from '../../models/PHPermissions';
import { FormGroup } from '@angular/forms';
import { IParamsField, IProductCardForm } from '../../../product/models/models';
import { ProductCard } from '../../../product/models/product-card';

import { SHARED_MODULES } from '../../../shared.';
import { HasAccessPipe } from '../../pipes/has-access.pipe';
import { MeasurementUnitPipe } from '../../pipes/measurement-unit.pipe';
import { UnitConverterPipe } from '../../pipes/unit-converter.pipe';

@Component({
    selector: 'app-product-phys-params-edit[product]',
    templateUrl: './product-phys-params-edit.component.html',
    styleUrls: ['./product-phys-params-edit.component.scss'],
	imports: [SHARED_MODULES, HasAccessPipe, MeasurementUnitPipe, UnitConverterPipe],
    standalone: true
})
export class ProductPhysParamsEditComponent implements OnInit {

	public fields: Array<IParamsField>;
	public readonly permissions: typeof PHPermissions = PHPermissions;

	@Input() product: ProductCard;
	@Input() productForm: FormGroup<IProductCardForm>;
	@Input() showErrors: boolean = false;

	constructor() {}

	ngOnInit(): void {
		this.fields = [
			{ name: 'height', label: 'HEIGHT', value: this.product.params.height },
			{ name: 'width', label: 'WIDTH', value: this.product.params.width },
			{ name: 'depth', label: 'DEPTH', value: this.product.params.depth }
		];
	}

	public numberInputValidate(event: KeyboardEvent, validDot: boolean = true): boolean {
		const blockedSymbols: string[] = ['e', 'E', '-', '+'];
		if (!validDot) blockedSymbols.push('.', ',');
		return !blockedSymbols.includes(event.key);
	}

	public wheelInput(event: WheelEvent): void {
		(event.target as HTMLElement).blur();
	}
}
